import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const UPDATE_REQUEST = 'realhub/orderItem/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/orderItem/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/orderItem/UPDATE_FAILURE'

const DELETE_REQUEST = 'realhub/orderItem/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/orderItem/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/orderItem/DELETE_FAILURE'

const SELECT_ORDER_ITEM = 'realhub/orderItem/SELECT_ORDER_ITEM'

// Initial State
const initialState = {
  errors: [],
  selectedId: null,
  updating: false,
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function selectOrderItem(orderItem){
  return (dispatch) => {
    dispatch({
      type: SELECT_ORDER_ITEM,
      selectedId: orderItem.id,
    })
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

export function hydrateOrderItem(orderItem){
  return (dispatch) => {
    dispatch(updateRequest())

    if (orderItem.id){
      const normalizedJson = normalize(orderItem, Schemas.ORDER_ITEM)
      dispatch(updateEntities(normalizedJson))
      dispatch(updateSuccess(normalizedJson))
    } else {
      dispatch(updateFailure(['Could not hydrate undefined orderItem.']))
    }
  }
}

export function updateOrderItem(orderItem, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      order_item: orderItem,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/admin/order_items/${orderItem.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ORDER_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

export function addOrderItemArtwork(orderItemId, artwork){
  return (dispatch, getState) => {
    const { orderItems } = getState().entities
    const orderItem = orderItems[orderItemId]

    if (orderItem){
      const updatedOrderItem = {
        ...orderItem,
        artwork_id: artwork.id,
        artwork,
      }

      const normalizedJson = normalize(updatedOrderItem, Schemas.ORDER_ITEM)
      dispatch(updateEntities(normalizedJson))
      dispatch(updateSuccess())
    } else {
      dispatch(updateFailure(['Could not add artwork to unknown item.']))
    }
  }
}

export function bulkUpdateOrderItems(orderItemIds, changes, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      order_item_ids: orderItemIds,
      order_item: changes,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api('/admin/order_items/bulk_update.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ORDER_ITEM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case SELECT_ORDER_ITEM:
      return {
        ...state,
        selectedId: action.selectedId,
      }
    default:
      return state
  }
}
